/** 

All function names start with "mobileMenu"
*/

function mobileMenuAddBacklinks() {

  const subMenus = document.getElementById('phoneMenu').querySelectorAll('.sub-menu');

  if(subMenus.length) {
      subMenus.forEach(function(submenu) {
          const backLink = document.createElement('li');
          const parent = submenu.parentNode;
          const parentCat = parent.querySelector('a').textContent;
          backLink.classList.add('mobile-submenu-back');
          backLink.innerHTML = '<span>&#8249;</span> ' + parentCat;
          submenu.prepend(backLink)
      });
  }
}
  
function mobileMenuHideAllSubmenus() {
    const itemsWithSubmenus = document.querySelectorAll('#phoneMenu .menu-item-has-children');

    if(itemsWithSubmenus.length) {
        itemsWithSubmenus.forEach(function(itemsWithSubmenu) {
            itemsWithSubmenu.classList.remove('mobile-submenu-show');
        });
    }
}

function mobileMenuToggleHander(ev) {
    const target = ev.target;

    console.log(target);

    if(target.classList.contains('mobileMenu-toggle-button') || target.closest('.mobileMenu-toggle-container')) {
        document.getElementById('phoneMenu').classList.toggle('phone-menu-is-open');
        document.querySelector('.mobileMenu-toggle-button').classList.toggle('is-open');
    }

    if(target.classList.contains('mobile-submenu-back')) {
        mobileMenuHideAllSubmenus();
        return;
    }

    if(! target.closest('.menuGlobalMobile')) {
        return;
    }

    if(target.parentNode.classList.contains('menu-item-has-children') || target.classList.contains('svg-menu-dropdown')) {
        target.closest('.menu-item-has-children').classList.add('mobile-submenu-show');
        ev.preventDefault();
    }
}
  
export default function mobileMenu() {
    const mobileMenuToggle = document.querySelector('.mobileMenu-toggle-container');

    if(! mobileMenuToggle) {
        return;
    }

    // phone menu can be left displayed if open and window resized to larger screen width

    document.getElementById('phoneMenu').classList.remove('phone-menu-is-open');
    document.querySelector('.mobileMenu-toggle-button').classList.remove('is-open');
   
    if(document.querySelector('.mobileMenu-toggle-button').getAttribute('data-listening')) {
        return; // listener already added - see end of this function
    }

    // If the menu isn't visible return. This is called on page load and each time the window resizes

    const compStyles = window.getComputedStyle(mobileMenuToggle);

    if( ! (compStyles.getPropertyValue('display') === 'block') ) {
            return;
    }

    mobileMenuAddBacklinks();

    document.addEventListener('click', mobileMenuToggleHander);

    document.querySelector('.mobileMenu-toggle-button').setAttribute('data-listening', true);
  }